export const tabbing_data = [
  {
    label: "Invoice Creation Date",
    id: 1,
    step: 1,
  },
  {
    label: "Before Due Date",
    id: 21,
    step: 2,
  },
  {
    label: "On Due Date",
    id: 41,
    step: 3,
  },
  {
    label: "After Due Date",
    id: 11,
    step: 4,
  },
  {
    label: "On Payment Collection Date",
    id: 15,
    step: 5,
  },
];
